import React from 'react';
import {useNavigate} from 'react-router-dom';
import { CloseCircleOutlined} from '@ant-design/icons';
import { Button } from 'antd';

import {ACTIVATE} from '../../config/routes';

import cls from '../Refund/Free/Success/Success.module.scss'


export const ActivateUniq = () => {

    const navigate = useNavigate()

    return (
        <div className={cls.page}>
            <div className={'content'}>
                <div className={cls.text}>
                    <h2 className={cls.error}><CloseCircleOutlined/> Ошибка</h2>
                    <p>Заявка на активацию с таким номером сертификата уже создана</p>
                    <p>Попробуйте еще раз</p>
                    <Button type={'primary'} size={'large'} onClick={() => navigate(ACTIVATE)}>Хорошо</Button>
                </div>
            </div>

        </div>
    )}


